<template>
  <div
    style="
      background-size: cover;
      background-image: url('../../assets/img/bgLogin.png');
    "
    :style="{ backgroundImage: `url(${backgroundBanners})` }"
    class="c-app m-0 align-items-center"
  >
    <CContainer>
      <CButton color="link" class="px-0 text-left" :href="'Login'"
        >Back to Login</CButton
      >
      <CCol sm="12" lg="12" class="mt-2 text-center">
        <div v-if="ErrorMessage == true" class="">
          <CAlert show color="danger">
            <strong class="text-danger mr-2">{{ Message }} </strong>
          </CAlert>
        </div>
        <div v-if="SuccessMessage == true" class="">
          <CAlert show color="success">{{ Message }} . Please Install Pickiddo Apps on google playstore or app store.</CAlert>
        </div>
      </CCol>

      <CCard class="custom-card m-0">
        <CRow>
          <CCol sm="12" class="justify-content-center m-0">
            <CRow class="p-2">
              <CCol sm="6" lg="6">
                <div class="text-center">
                  <img style="width: 80px" src="../../assets/img/Logo.png" />
                  <h4 class="mt-2">Hi, Welcome to Sign Up !</h4>
                  <p class="text-muted ml-5 mr-5">
                    Install Pickiddo Apps and start to connect with your student
                    once done Sign Up.
                  </p>

                  <a
                    href="https://play.google.com/store/apps/details?id=com.cellnet.pickiddo"
                  >
                    <img
                      style="max-width: 150px"
                      class="mt-2 mb-2"
                      src="../../assets/img/gp2black.png"
                    />
                  </a>
                  <a href="https://apps.apple.com/my/app/pickiddo/id1366167288">
                    <img
                      style="max-width: 150px"
                      class="ml-2 mt-2 mb-2"
                      src="../../assets/img/gpblack.png"
                    />
                  </a>
                </div>

                <CCol sm="12" lg="12" class="justify-content-center">
                  <CRow>
                    <CCol sm="12" lg="12" class="p-2">
                      <CRow>
                        <CCol sm="12" lg="12">
                          <CRow class="d-flex">
                            <CCol sm="12" class="mt-2">
                              Name
                              <CInput
                                type="text"
                                v-model="name"
                                placeholder="Enter your Name"
                              />
                              Email
                              <CInput
                                type="text"
                                v-model="email"
                                placeholder="Enter your Email"
                              />
                              Phone Number
                              <CInput
                                type="text"
                                v-model="phone"
                                placeholder="Enter your Phone"
                              />
                              Password
                              <CInput
                                type="password"
                                v-model="password"
                                placeholder="Enter your Password"
                              />
                            </CCol>
                          </CRow>
                        </CCol>

                        <CCol sm="12" lg="12" class="text-center">
                          <CButton
                            color="success"
                            @click="InsertSignUp"
                            class="custom-btn"
                            block
                            >SIGN UP</CButton
                          >
                        </CCol>
                      </CRow>
                    </CCol>
                  </CRow>
                </CCol>
              </CCol>
              <CCol sm="6" lg="6">
                <CCard
                  style="border-radius: 20px;background: cornflowerblue;"
                  class="text-center text-white"
                  body-wrapper
                >
                  <CCardBody>
                    <h2>Register your Account</h2>
                    <p>
                      Pickiddo is a platform to manage online tuition by
                      providing on-demand tuition services.
                    </p>
                    <img
                      style="max-width: 100%"
                      src="../../assets/img/imgVector.png"
                    />
                     <br/><br /><br /><br /><br />
                  </CCardBody>
                </CCard>
              </CCol>
            </CRow>
          </CCol>
        </CRow>
      </CCard>
    </CContainer>
  </div>
</template>

<script>
import Vue from "vue";
Vue.use(require("vue-moment"));
import vSelect from "vue-select";
import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";
Vue.component("v-select", vSelect);

import "vue-select/dist/vue-select.css";
import "vue-select/src/scss/vue-select.scss";

import backgroundBanners from "../../assets/img/bgLogin.png";

// Tell Vue to install the plugin.
Vue.use(VuejsDialog);
import _ from "lodash";

export default {
  name: "Login",
  data() {
    return {
      findtutors: [],
      teachers: [],
      Busy: false,
      status: false,

      name: "",
      email: "",

      phone: "",
      password: "",

      ErrorMessage: false,
      SuccessMessage: false,

      Message: "",
      backgroundBanners: "",
    };
  },
  async mounted() {},
  methods: {
    InsertSignUp() {
      const formData = new FormData();

      formData.append("name", this.name);
      formData.append("email", this.email);
      formData.append("password", this.password);

      formData.append("userType", "teacher");
      formData.append("phone", this.phone);

      return this.$API
        .post(this.$SignUpTutor, formData, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.Message = response.data.Message;
            this.SuccessMessage = true;
          } else {
            this.Message = response.data.Message;
            this.ErrorMessage = true;
          }
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.data);
            this.Error = true;
            this.Message = error;
            this.Message = "Error";
            this.Message = response.data.Message;
            this.ErrorMessage = true;
          }
        });
    },
  },
};
</script>
